import { useState } from 'react';
import { Grid } from '@mui/material';

import Navbar from 'components/Navbar';
import { Select } from 'components/Inputs/Select';
import RemoveEmployeeForm from 'components/Users/Forms/RemoveEmployee';
import ReassignEmployeeForm from 'components/Users/Forms/ReassignEmployee';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

enum EmpUpdateEnum {
  'REMOVE' = 'REMOVE',
  'REASSIGN' = 'REASSIGN',
}

const UpdateEmployeePage = () => {
  const [updateType, setUpdateType] = useState<EmpUpdateEnum>(EmpUpdateEnum.REMOVE);

  return (
    <Navbar
      title={`${updateType === EmpUpdateEnum.REMOVE ? 'Remove' : 'Reassign'} Employee(s) - ${getSelectedObjectiveGoalsYear()}`}
    >
      <Grid container item xs={12} md={10} lg={8} xl={6} rowGap={2} columnSpacing={1.5} mb={2}>
        <Grid item xs={12}>
          <Select
            value={updateType}
            onChange={val => setUpdateType(val)}
            options={Object.keys(EmpUpdateEnum).map(k => ({ label: k, value: EmpUpdateEnum[k] }))}
            label="Remove / Reassign Employee"
          />
        </Grid>
      </Grid>
      {updateType === EmpUpdateEnum.REMOVE && <RemoveEmployeeForm />}
      {updateType === EmpUpdateEnum.REASSIGN && <ReassignEmployeeForm />}
    </Navbar>
  );
};

export default UpdateEmployeePage;
